import {
    ActionIcon,
    Affix,
    Box,
    Button,
    CloseButton,
    Collapse,
    Flex,
    Transition,
} from "@mantine/core";
import { IconArrowUp, IconPlus, IconX } from "@tabler/icons";
import { useViewportSize, useWindowScroll } from "@mantine/hooks";
import { useState } from "react";
import { useEffect } from "react";

const ScrollTop = ({ children = null }) => {
    const [scroll, scrollTo] = useWindowScroll();
    const [opened, setOpened] = useState(false);

    // console.log("scroll : ", scroll, "width: ", width);
    // let qitems = form.values.
    // console.log(scroll, scrollTo);

    return (
        <Affix position={{ bottom: 20, right: 20 }}>
            <Transition transition="slide-down" mounted={scroll.y > 0}>
                {(transitionStyles) => (
                    <Flex maw={300} gap={10} align="end" direction="column">
                        <Collapse in={opened}>
                            {!!children && children}
                        </Collapse>
                        {!!!children && (
                            <Button
                                leftIcon={<IconArrowUp size={16} />}
                                style={transitionStyles}
                                onClick={() => scrollTo({ y: 0 })}
                            >
                                Scroll to top
                            </Button>
                        )}
                        {!!children && (
                            <ActionIcon
                                variant="filled"
                                color={opened ? "red" : "green"}
                                radius="xl"
                                size={"xl"}
                                style={transitionStyles}
                                onClick={() => setOpened((o) => !o)}
                            >
                                {!opened && <IconPlus />}
                                {opened && <IconX />}
                            </ActionIcon>
                        )}{" "}
                    </Flex>
                )}
            </Transition>
        </Affix>
    );
};

export default ScrollTop;
